import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js';
import{ RowsPerPageSelector, SearchTable, DataTable,customDataTableStyles } from './../../common/helper/table-imports.js'; 
import CashoutService from "../../../services/cashout-service.js";
import { cashoutColumns } from './cashout-col.component.js'


const CashoutList = () => { 
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [cashouts, setCashout] = useState([]);
  
const download = (batch_id)=> {
  setLoading(true)
  CashoutService.downloadBatchfile(batch_id)
      .then(response => {
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'batch.csv'); // Specify the file name here
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        toast.success(MESSAGES.FILE_DOWNLOADED)
        setLoading(false);
       
      })
      .catch(error => {
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });
}

 
  const [columns,setColumns] = useState(cashoutColumns(download));

  const getBatchListing = (e) => {
    setLoading(true);
    CashoutService.getCashout()
      .then(response => {
        console.log(response.data.data.list)
        setCashout(response.data.data.list);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  }
  useEffect(() => {
    getBatchListing();
    document.body.style.backgroundColor = '#f0f6fa';
    
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);
  const navigate = useNavigate();
  const addNewBatch = (e) => {
    navigate('/add-new-batch');
  }
  
  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey(prevKey => prevKey + 1);
  };

const paginationComponentOptions = { 
  noRowsPerPage :true
}
const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
};

const escapeRegExp = (string) => {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
const flattenValues = (obj) => {
  const values = [];
  const traverse = (item) => {
    if (Array.isArray(item)) {
      item.forEach((subItem) => traverse(subItem));
    } else if (typeof item === 'object' && item !== null) {
      Object.entries(item).forEach(([key, value]) => {
        if (!excludedKeys.includes(key)) {
          traverse(value);
        }
      });
    } else {
      values.push(item);
    }
  };
  traverse(obj);
  return values;
};
const excludedKeys = ['admin_detail'];
const filteredData = cashouts.filter((row) => {
  const flattenedValues = flattenValues(row);

  // Apply the search on the flattened array of values
  return flattenedValues.some(
    (value) => new RegExp(escapeRegExp(searchTerm), 'i').test(value)
  );
});

  return (
    <div>
            <LoaderOverlay loading={loading} />

    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
                    <div className="container" style={{backgroundColor: 'white'}}>
                      <div className="filterBtn">
                        
                      <SearchTable searchTerm={searchTerm} handleSearchChange={handleSearchChange}/>

                        <div className="dt-buttons ui-buttonset"><a className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg" tabIndex={0} aria-controls="examplemgm"><span className="ui-button-text" onClick={addNewBatch}>Add New</span></a></div>
                  </div>

                  <RowsPerPageSelector rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
                      <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" style={{position: 'relative'}}>


                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              expandOnRowClicked = {true}
                              customStyles={customDataTableStyles}
                        />
                        </div>
                      </div>
                    </div>
                  </div>
                

                 

                  </div>
           
               

)

}
function mapStateToProps(state) {
   const userData = state.authReducer.user;
   return { userData };
 }
 export default withAuth(connect(mapStateToProps)(CashoutList));

 
 